import { render, staticRenderFns } from "./parameter_keluaran_pelayanan.vue?vue&type=template&id=1f36d9f2&"
import script from "./parameter_keluaran_pelayanan.vue?vue&type=script&lang=js&"
export * from "./parameter_keluaran_pelayanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports